import { Container, Row, Col, Button } from 'react-bootstrap';
import OfficeCarousel from '../../../../components/carousels/office-carousel';
import { useScroll } from '../../../../context/scroll-context';

const CarouselSection = () => {
    const { scrollToSection, contactform } = useScroll();

    const handleScrollAndClose = (refName) => {
        scrollToSection(refName);
    };

    return (
        <section className="py-5">
            <Container>
                <Row className="mb-4">
                    <Col xs={12} md={6}>
                        <OfficeCarousel />
                    </Col>
                    <Col xs={12} md={6} className="d-flex align-items-center">
                        <div className="text-primary">
                            <h2 className="mb-4 ft-wt-700">Our Development Centre
                            </h2>
                            <p className="mb-3">
                                ACube operates from a well equipped development center, furnished with the advanced technology and networked work environment with robust security controls to assure our client of reliability, security and scalability for the assigned projects. The amenities operate around the clock enabling the teams to support clients across the continents and time zones. In addition to work areas, these facilities also contain Conferencing, training, development and recreational areas and amenities for our employees.
                            </p>
                            <div>
                                <Button variant="primary" onClick={() => handleScrollAndClose(contactform)} >
                                    Start now
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default CarouselSection;
